export default "/_next/static/images/paper-strip-b8330bc715510fda8b68dec8f711bf50.png";